var _path, _path2, _path3, _path4, _g, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayoutEmptyStateImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.897 174.3c-.401.001-.602-.197-.603-.593l-.44-155.459c0-.396.2-.594.6-.595l230.363-.651c.401-.002.602.196.603.592l.439 155.459c.001.396-.199.595-.6.596l-230.362.651z",
    fill: "#E9FAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.503 34.82c-.401 0-.602-.02-.602-.064l-.048-17.037c0-.043.2-.065.601-.066l230.363-.651c.401-.002.601.02.601.063l.048 17.037c.001.043-.2.065-.601.066l-230.362.651z",
    fill: "#D3EFF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.553 82.863c-1.39.004-2.085-.068-2.085-.214L42.4 58.682c0-.147.694-.222 2.084-.226l186.191-.526c1.39-.004 2.085.067 2.085.214l.068 23.967c0 .146-.694.222-2.084.225l-186.191.527zM44.553 115.939c-1.39.004-2.085-.068-2.085-.214L42.4 91.758c0-.147.694-.222 2.084-.226l186.191-.526c1.39-.004 2.085.067 2.085.214l.068 23.967c0 .146-.694.222-2.084.226l-186.191.526zM44.553 149.015c-1.39.004-2.085-.067-2.085-.214l-.068-23.967c0-.146.694-.222 2.084-.226l186.191-.526c1.39-.004 2.085.068 2.085.214l.068 23.967c0 .147-.694.222-2.084.226l-186.191.526zM176.126 234l-47.172-8.5 4.5-19.5 6.5-19c24.515 19 47.015-11 52.672-14 4.525-2.4 15.4-3.333 20.271-3.5l48.557-4.5v62l-85.328 7z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M374.853 229s-3-5-5-5-9 1.4-11 5M358.22 215.969s-4.131-4.115-6.07-3.626c-1.94.489-8.385 3.558-9.444 7.537M327.59 212.848s-4.132-4.114-6.071-3.625c-1.939.489-8.385 3.558-9.444 7.537M301.59 213.848s-2.404-4.904-6.071-3.626c-3.666 1.278-6.666 3.278-10.665 7.778",
    stroke: "#23547B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.25 179.726a34.889 34.889 0 0026.674 7.528 140.155 140.155 0 0034.408-11.991 49.992 49.992 0 0135.609-3.531M296.619 248.877c3.265.699 6.625.834 9.935.4a49.806 49.806 0 0012.003-3.997 471.83 471.83 0 0147.345-13.323l7.335-2.198a4.138 4.138 0 002.468-1.532c.1-.551 0-1.666 0-1.666v-2.797c.261-4.914-6.558-6.708-13.487-7.264M266.911 249.937a54.852 54.852 0 0010.308 1.547 27.31 27.31 0 009.736-.866 53.806 53.806 0 0012.003-6.129c19.471-11.657 40.009-15.255 59.281-27.312a2.6 2.6 0 001.067-.999 2.532 2.532 0 000-1.199 8.805 8.805 0 00-4.668-6.662c-5.97-3.727-12.978-2.666-20.002-1.109",
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.09 249.327a73.458 73.458 0 0022.397 2.663 33.412 33.412 0 0010.136-1.732 53.81 53.81 0 0011.536-6.662c14.537-10.125 30.541-15.854 45.811-24.314l7.202-3.931a4.535 4.535 0 002.201-2.131 4.136 4.136 0 000-1.799l-.334-2.998c-.848-7.52-15.182-5.188-23.503-3.18",
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.852,
    cy: 170,
    r: 43,
    fill: "#FDE19C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.852,
    cy: 170,
    r: 34,
    transform: "rotate(30 248.852 170)",
    fill: "#FDD269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.852 199.444c16.261 9.389 37.056 3.817 46.444-12.445 9.389-16.262 3.817-37.056-12.444-46.444",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.474 227.538a132.957 132.957 0 0126.674-14.322c5.534-2.132 11.336-3.797 17.137-5.396 5.802-1.598 33.675-8.393 31.808 4.264-.934 6.195-14.937 9.126-19.605 11.258l-28.54 12.923c-14.537 6.662-25.74 16.254-42.277 13.856a185.493 185.493 0 01-50.346-14.922M165.597 200.568a15.333 15.333 0 0011.869 5.463c5.935 0 11.203-2.665 16.938-2.532 11.136 0 17.471 8.127 25.206 15.055",
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.25,
    y: 150,
    width: 10,
    height: 38,
    rx: 5,
    fill: "#23547B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 245.505,
    cy: 152.306,
    rx: 13.484,
    ry: 8.516,
    transform: "rotate(-42.846 245.505 152.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 236.25,
    cy: 171,
    r: 4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.399 33.1h-.7c-1.8 0-3.2-1.4-3.2-3.2v-1.7c0-.7-.5-1.2-1.2-1.2s-1.2.5-1.2 1.2v1.7c0 1.8-1.4 3.2-3.2 3.2h-.7c-.7 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2h.7c1.8 0 3.2 1.4 3.2 3.2v2.2c0 .7.5 1.2 1.2 1.2s1.2-.5 1.2-1.2v-2.2c0-1.8 1.4-3.2 3.2-3.2h.7c.7 0 1.2-.5 1.2-1.2s-.5-1.2-1.2-1.2z",
    fill: "#7FD8EE"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.537 175.898c-10.05 12.295.502 23.056 5.457 26.275 16.155 3.951 30.263-7.441 39.096-14.198 16.582-12.697 73.879-86.458 90.462-99.155 21.352-16.452 44.537-33.595 71.198-36.086 34.509-3.212 67.48 23.163 70.037 56.156.968 11.858-2.933 25.321-10.084 37.522M281.975 131.588c6.135-23.32-5.537-40.008-20.875-46.305",
    stroke: "#00A8D7",
    strokeWidth: 2.018,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.08 6.08"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4 206.1h-.7c-1.8 0-3.2-1.4-3.2-3.2v-1.7c0-.7-.5-1.2-1.2-1.2s-1.2.5-1.2 1.2v1.7c0 1.8-1.4 3.2-3.2 3.2h-.7c-.7 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2h.7c1.8 0 3.2 1.4 3.2 3.2v2.2c0 .7.5 1.2 1.2 1.2s1.2-.5 1.2-1.2v-2.2c0-1.8 1.4-3.2 3.2-3.2h.7c.7 0 1.2-.5 1.2-1.2s-.5-1.2-1.2-1.2zM102.8 191.1h-.5c-1.2 0-2.2-1-2.2-2.2v-1.1c0-.4-.4-.8-.8-.8s-.8.4-.8.8v1.2c0 1.2-1 2.2-2.2 2.2h-.5c-.4 0-.8.4-.8.8s.4.8.8.8h.5c1.2 0 2.2 1 2.2 2.2v1.5c0 .4.4.8.8.8s.8-.4.8-.8V195c0-1.2 1-2.2 2.2-2.2h.5c.4 0 .8-.4.8-.8.1-.6-.3-.9-.8-.9z",
    fill: "#7FD8EE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(99)",
    d: "M0 0h301v256H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutEmptyStateImage);
export default __webpack_public_path__ + "static/media/payout-empty-state-image.24fd22dce5dec47e5d195d426b8feb2b.svg";
export { ForwardRef as ReactComponent };